export function Table({
  titles = [],
  caption = "",
  children,
  responsive = false,
  text = null,
}) {
  return (
    <div className={responsive ? "table-responsive" : ""}>
      <table className="table table-sm table-bordered table-striped table-hover">
        {caption && <caption>{caption}</caption>}

        <thead>
          <tr className="text-center">
            {titles.map((title, i) => (
              <th key={i}>{title}</th>
            ))}
          </tr>
        </thead>

        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
